import { FeaturedCategoryDto } from '../../dto/featuredcategory/featuredcategorydto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';

export interface FeaturedCategoriesRequest extends APIRequest
{
    getFeaturedCategoriesRequest(): FeaturedCategoryDto;
}

export class FeaturedCategoriesRequestImpl extends APIRequestDtoImpl implements FeaturedCategoriesRequest
{
    constructor(private featuredCategoryData: FeaturedCategoryDto)
    {
        super();
    }

    getFeaturedCategoriesRequest(): FeaturedCategoryDto
    {
        return this.featuredCategoryData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesrequest.tsx